import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const ReturnPolicy = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        fill="none"
        viewBox="0 0 32 32"
        ref={forwardedRef}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_7074_628)">
          <path
            d="M17.9483 29.775L6.58575 23.7125V9.83752L17.9483 3.90002L28.7108 9.83752V23.7125L17.9483 29.775Z"
            fill="#F8B200"
          />
          <path
            d="M6.58575 9.83752L17.9483 15.775M6.58575 9.83752V23.7125L17.9483 29.775M6.58575 9.83752L17.9483 3.90002L28.7108 9.83752M17.9483 15.775V29.775M17.9483 15.775L28.7108 9.83752M17.9483 29.775L28.7108 23.7125V9.83752"
            stroke="#2B2F38"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.992 20.4625V10.65L14.4608 14.0875V22.775L9.992 20.4625Z"
            fill="#99E538"
            stroke="#2B2F38"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.7108 23.9625V17.525L25.6307 14.65V21.15L20.7108 23.9625Z"
            fill="white"
            stroke="#2B2F38"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.4438 2.51866L3.00569 10.3376L14.4438 17.7751L14.4438 13.0251C21.4432 12.4625 24.3829 13.2931 25.1307 14.9C25.7861 16.3083 24.8182 18.2125 23.0057 19.4625C28.6307 19.4626 30.5367 15.8366 30.3807 13.025C30.1897 9.58421 26.0858 6.08759 14.4438 7.21259L14.4438 2.51866Z"
            fill="#E61D27"
            stroke="#2B2F38"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_7074_628">
            <rect width="32" height="32" fill="white" transform="translate(0.976196)" />
          </clipPath>
        </defs>
      </svg>
    )
  },
)

export default ReturnPolicy
